<p-dialog [(visible)]="displayDialog" [style]="{ width: '30vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="true" (onHide)="onDialogClosed()" header="Nuevo Tipo">
    <form [formGroup]="form" (ngSubmit)="guardar()" appPermissionControl="P281F0001">
        <div class="form-row">
            <div class="form-field">
                <p-dropdown [options]="tipos" [(ngModel)]="tipoSeleccionado" [ngModelOptions]="{standalone: true}" optionLabel="label" optionValue="value" appendTo="body"
                    placeholder="Seleccione un tipo" class="w-100" appPermissionControl="P281K0001"></p-dropdown>
                <label>Tipo</label>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!tipoSeleccionado || loading" appPermissionControl="P281B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                Guardar
            </button>
        </div>
    </form>
</p-dialog>

<p-toast position="bottom-right"></p-toast> 